import { extendTheme } from "@chakra-ui/react";
import { components } from "./components";
import { breakpoints } from "./foundations/breakpoints";
import { colors } from "./foundations/colors";
import { radii, sizes, space, transition } from "./foundations/space";
import { typography } from "./foundations/typography";
import { styles } from "./globalStyles";

export const theme = extendTheme({
  config: { initialColorMode: "light", useSystemColorMode: false },
  breakpoints,
  colors,
  ...typography,
  space,
  sizes,
  radii,
  transition,
  styles,
  components,
});
